import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import cz from 'react-phone-number-input/locale/cz.json';
import en from 'react-phone-number-input/locale/en.json';
import de from 'react-phone-number-input/locale/de.json';
import sk from 'react-phone-number-input/locale/sk.json';
import 'react-phone-number-input/style.css';
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import { FiHelpCircle } from "react-icons/fi";
import EnigooToolTip from "./EnigooToolTip";

export const EnigooPhoneField = ({
                                     name,
                                     placeHolder = "Zadejte telefonní číslo...",
                                     label,
                                     inline = false,
                                     defaultCountry = "CZ",
                                     limitMaxLength = false,
                                     outsideClassName = "w-full",
                                     onKeyDown = null,
                                     mandatory = false,
                                     toolTip = null,
                                     toolTipPosition = "right"
                                 }) => {
    const { t, i18n } = useTranslation();
    const [labels, setLabels] = useState(cz);
    const [initCountry, setInitCountry] = useState(defaultCountry);

    const validatePhoneField = (value) => {
        if (!mandatory && !value) return undefined;
        if (mandatory && (!value || value === "")) return t("basics.requireField");
        if (typeof value === "string" && !isValidPhoneNumber(value)) return t("basics.phoneInvalid");
        return undefined;
    };

    useEffect(() => {
        switch (i18n.language) {
            case "cs": setLabels(cz); setInitCountry("CZ"); break;
            case "en": setLabels(en); setInitCountry("GB"); break;
            case "de": setLabels(de); setInitCountry("DE"); break;
            case "sk": setLabels(sk); setInitCountry("SK"); break;
            default: setLabels(cz); setInitCountry("CZ");
        }
    }, [i18n.language]);

    return (
        <div className={outsideClassName}>
            <div className={`form-element ${inline ? 'form-element-inline' : ''}`}>
                <div className="form-label flex flex-row">
                    {label}
                    {toolTip && (
                        <>
                            <FiHelpCircle data-tip data-for={"_tooltip_" + name} key={name}
                                          className={"ml-2 text-red-900"} size={18}/>
                            <EnigooToolTip content={toolTip} id={"_tooltip_" + name} place={toolTipPosition}/>
                        </>
                    )}
                </div>
                <Field name={name} validate={validatePhoneField}>
                    {({input, meta}) => (
                        <>
                            <div className={`form-input flex flex-row items-center justify-start ${meta.error ? "form-input-invalid" : ""}`}>
                                <PhoneInput
                                    {...input}
                                    onKeyDown={onKeyDown}
                                    labels={labels}
                                    international
                                    placeholder={placeHolder}
                                    defaultCountry={initCountry}
                                    limitMaxLength={limitMaxLength}
                                    countryCallingCodeEditable={false}
                                    useNationalFormatForDefaultCountryValue
                                    onChange={(value) => input.onChange(value)}
                                />
                            </div>
                            {meta.error && <div className="form-error">{meta.error}</div>}
                        </>
                    )}
                </Field>
            </div>
        </div>
    );
};

EnigooPhoneField.propTypes = {
    name: PropTypes.string.isRequired,
    placeHolder: PropTypes.string,
    label: PropTypes.string.isRequired,
    inline: PropTypes.bool,
    defaultCountry: PropTypes.string,
    limitMaxLength: PropTypes.bool,
    outsideClassName: PropTypes.string
};
